export const DASHBOARD_ACCESS_KEY = 'dashboardAccessGranted';
export const DASHBOARD_ACCESS_EVENT = 'dashboard-access-changed';

export const hasDashboardProtection = () => Boolean(localStorage.getItem('dashboardPassword'));

export const isDashboardAccessGranted = () => sessionStorage.getItem(DASHBOARD_ACCESS_KEY) === 'true';

export const grantDashboardAccess = () => {
	sessionStorage.setItem(DASHBOARD_ACCESS_KEY, 'true');
	window.dispatchEvent(new Event(DASHBOARD_ACCESS_EVENT));
};

export const clearDashboardAccess = () => {
	sessionStorage.removeItem(DASHBOARD_ACCESS_KEY);
	window.dispatchEvent(new Event(DASHBOARD_ACCESS_EVENT));
};